import React, { useState, useRef } from 'react'
import CommonTable from '../../../../components/common/common-table/common-table'
import PackagingTypeManagementColumnModel from './packaging-type-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { ApiRequest } from '../../../../services/api/api'
import { convertNumericFields } from '../../../../services/lib/utils/helpers'
import SweetAlertService from '../../../../services/lib/utils/sweet-alert-service'

// 自动计算 Sleeve Qty 和 Packaging Type
const calculateDerivedFields = (dataDetail: any) => {
  const { quantity, sleevePkt, packagingCategory } = dataDetail

  // 计算 Sleeve Qty = Carton Qty / Qty per Sleeve
  let sleeveQty = 0
  if (quantity && sleevePkt && sleevePkt !== 0) {
    sleeveQty = Math.floor(quantity / sleevePkt)
  }

  // 生成 Packaging Type = "Carton Qty / Packaging Category / Sleeve Qty * Qty per Sleeve"
  let packagingTypeName = ''
  if (quantity && packagingCategory && sleeveQty && sleevePkt) {
    packagingTypeName = `${quantity} / ${packagingCategory} / ${sleevePkt} `
  }

  return {
    ...dataDetail,
    sleeveQty,
    packagingTypeName
  }
}

const PackagingTypeManagementPage = (): any => {
  const [data, setData] = useState<any[]>([])
  const tableRef = useRef<any>()

  // 获取数据
  const fetchData = (isShowSpinner = true) => {
    ApiRequest({
      urlInfoKey: urlKey.PackagingType,
      callBackFunction: (result: any) => {
        // 显示时自动计算字段
        if (Array.isArray(result)) {
          setData(result)
        } else {
          setData(result)
        }
      },
      type: 'get',
      isShowSpinner
    })
  }

  // 初始加载
  React.useEffect(() => {
    fetchData()
  }, [])

  // 更新数据
  const updateData = async (newData: any[], dataDetail: any, type: string) => {
    const { quantity, sleevePkt } = dataDetail

    // 校验：Sleeve Qty 必须是整数（Carton Qty 必须能被 Qty per Sleeve 整除）
    if (quantity && sleevePkt && sleevePkt !== 0) {
      if (quantity % sleevePkt !== 0) {
        await SweetAlertService.errorMessage('Sleeve Qty must be an integer. Please ensure Carton Qty is evenly divisible by Qty per Sleeve.')
        return Promise.reject()
      }
    }

    // 先自动计算字段
    const calculatedData = calculateDerivedFields(dataDetail)
    // 再转换数字字段
    const processedData = await convertNumericFields(
      calculatedData,
      PackagingTypeManagementColumnModel.PackagingTypeManagementColumn
    )

    return ApiRequest({
      urlInfoKey: urlKey.PackagingType,
      type: type,
      data: processedData,
      callBackFunction: () => {
        // 保存成功后重新获取数据
        fetchData(false)
      }
    })
  }

  return (
    <CommonTable
      title="Packaging Unit"
      column={PackagingTypeManagementColumnModel.PackagingTypeManagementColumn}
      initData={data}
      editable={true}
      updateData={updateData}
      setTableData={setData}
    />
  )
}

export default PackagingTypeManagementPage